import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'

import { DownloadBanner } from 'components/DownloadBanner'
import { Header } from 'components/Header'
import { UpdateSubscriptionModal } from 'components/UpdateSubscriptionModal'

import { selectEmailAuth } from 'root-redux/selects/user'

import { useScrollToTop } from 'hooks/useScrollToTop'

import { checkOpenInAppLinkAvailability } from 'helpers/checkOpenInAppLinkAvailability'

import { goBack, replaceHistory } from 'browser-history'
import { PageId } from 'page-constants'

import { useRetentionFlowV2Config } from '../../hooks/useRetentionFlowV2Config'
import { FlowScope } from '../FlowScope'
import { StyledFlowPageContainer as S } from './FlowPageContainer.styles'

type TProps = {
  children: React.ReactNode
  hasNavigation?: boolean
  className?: string
}

export const FlowPageContainer: React.FC<TProps> = ({
  children,
  hasNavigation = false,
  className,
}) => {
  const { t } = useTranslation()
  const { copyKey } = useRetentionFlowV2Config()
  const { search } = useLocation()
  const emailAuth = useSelector(selectEmailAuth)

  const hasDownloadBanner = checkOpenInAppLinkAvailability() && !emailAuth

  useScrollToTop()

  const goToAccountPage = () => {
    replaceHistory({ pathname: PageId.SUBSCRIPTION_DETAILS, search })
  }

  return (
    <FlowScope>
      {hasDownloadBanner ? (
        <DownloadBanner />
      ) : (
        <Header hasBottomOffset={false} />
      )}
      <UpdateSubscriptionModal />
      {hasNavigation && (
        <S.Navigation hasDownloadBanner={hasDownloadBanner}>
          <S.BackButton
            type="button"
            aria-label={t('login.back')}
            onClick={goBack}
          />
          <S.NavigationTitle>{t(`${copyKey}.headerTitle`)}</S.NavigationTitle>
          <S.CloseButton
            type="button"
            aria-label={t(`${copyKey}.close`)}
            onClick={goToAccountPage}
          />
        </S.Navigation>
      )}
      <S.Content
        hasTopOffset={hasDownloadBanner && !hasNavigation}
        className={className}
      >
        {children}
      </S.Content>
    </FlowScope>
  )
}
